export default "__VITE_ASSET__gS8q0Wj4__"